import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import {
  EVENT_DATE_LIST,
  SERVICE_TEMP_CONSTANTS
} from "@/modules/ServiceTemplate/constants/ServiceTemplateConstants";
import { SectionGroupDetail } from "@/modules/ServiceTemplate/models/SectionGroupDetail";
import {
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  NOTIFICATION_CONFIG,
  NOTIFICATION_MODAL_TYPE
} from "@/modules/Notification/constants/NotificationConstants";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import AddFormTemplate from "@/shared/components/AddFormTemplate/AddFormTemplate.vue";
import { NotificationConfig } from "@/modules/Notification/models/NotificationConfig";
import { TaskRule } from "@/modules/ServiceTemplate/models/TaskRule";
import { NotificationParams } from "@/modules/Notification/models/NotificationParams";
import { RoleInfo } from "@/modules/Roles/models/RoleInfo";
import { TaskService } from "../../services/TaskService";
import {
  ADMIN_DEPENDENCY,
  TASK_CONSTANTS,
  VALUES_RESPONSIBLES
} from "../../constants/TaskConstants";
import { Task } from "../../models/Task";
import { ActionId } from "@/modules/Dashboards/AdminDashboard/models/ActionId";
import { ActionParameters } from "@/modules/Dashboards/AdminDashboard/models/ActionParameters";
import {
  ACTION_CARD_EVENT,
  ACTION_EVENT,
  DOCUMENT_STATES
} from "@/modules/Dashboards/AdminDashboard/constants/ActionConstants";
import NotificationModal from "@/modules/Notification/components/NotificationModal/NotificationModal.vue";
import lodash from "lodash";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { UserService } from "@/modules/User/services/UserService";
import { USER_STATES } from "@/modules/User/constants/UserConstants";
import { Http } from "@status/codes";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { LOGIN_CONSTANTS } from "@/modules/Login/constants/LoginConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { ReportValidationsForm } from "@/modules/FormTemplate/models/ReportValidationsForm";
import { AVAILABILITY_CONSTANTS } from "@/modules/Availability/constants/AvailabilityConstants";
import { DependenciesService } from "../../../Dependencies/services/DependenciesService";
import { QuerySendMultiple } from "@/shared/models/FormQuerySend";
import { FILTER_QUERY_DEFAULT_DEPENDENCIES } from "@/modules/Dependencies/constants/DependenciesConstants";
import { UserQuery } from "@/modules/User/models/UserQuery";
import { UserPagination } from "@/modules/User/models/UserPagination";
import { TASK_FORM_LABELS } from "@/modules/GeneralRules/constants/GeneralRulesConstants";

@Component({
  name: "AddTask",
  components: {
    AddFormTemplate,
    NotificationModal,
    DynamicSelect,
    ModalTemplate
  }
})
export default class AddTask extends Vue {
  @Prop() private userRoleList!: RoleInfo[];
  @Prop() private userInfoParams!: NotificationParams[];
  @Prop() private isTaskAction!: boolean;
  @Prop() private userIdArray!: ActionId[];
  @Prop() private mainFilter!: string;
  @Prop() private showRoleList!: boolean;
  @Prop() private defaultResponsible!: string;
  @Prop() private defaultRelated!: string[];
  @Prop() private fromProfile!: boolean;
  @Prop() private selectCountUsers!: number;

  @Inject() taskService!: TaskService;
  @Inject() userService!: UserService;
  @Inject() dependenciesService!: DependenciesService;

  task: TaskRule = {
    eventDate: "",
    startDate: 0,
    formTemplates: []
  };
  notifications: NotificationConfig[] = [];
  navigateBtnTasks = 0;
  eventDateList = EVENT_DATE_LIST;

  TYPE = NOTIFICATION_CONFIG.RULE_TYPES.TASK;
  TITLE = TASK_CONSTANTS.LABELS.TITLE;
  TASKDATA = TASK_CONSTANTS.LABELS.TASKDATA;
  FORM = TASK_CONSTANTS.LABELS.FORM;
  NOTIFICATIONS = TASK_CONSTANTS.LABELS.NOTIFICATIONS;
  INPUT_NAME = TASK_CONSTANTS.LABELS.NAME;
  INPUT_RESPONSIBLE = TASK_CONSTANTS.LABELS.RESPONSIBLE;
  INPUT_DEPENDENCY = AVAILABILITY_CONSTANTS.LABEL.DEPENDENCY;
  INPUT_RELATED = TASK_CONSTANTS.LABELS.RELATED;
  ADD_NOTIFICATIONS =
    SERVICE_TEMP_CONSTANTS.BUTTONS_CREATE_TEMP.ADD_NOTIFICATIONS;
  RULE_STATE = SERVICE_TEMP_CONSTANTS.LABEL.RULE_STATE;
  EVENT_DATE = SERVICE_TEMP_CONSTANTS.LABEL.EVENT_DATE;
  START_DATE = SERVICE_TEMP_CONSTANTS.LABEL.START_DATE;
  ADD_FORM_TEMP = SERVICE_TEMP_CONSTANTS.BUTTONS_CREATE_TEMP.ADD_FORMS;
  TASKS_FORM_TEMPS = SERVICE_TEMP_CONSTANTS.BUTTON.TASKS_FORM_TEMPS;
  TASKS_DATE_REF = SERVICE_TEMP_CONSTANTS.BUTTON.TASKS_DATE_REF;
  TASKS_NOTIFICATIONS = SERVICE_TEMP_CONSTANTS.BUTTON.TASKS_NOTIFICATIONS;
  SAVE_BTN = TASK_CONSTANTS.BUTTONS.SAVE_BTN;
  CANCEL_BTN = TASK_CONSTANTS.BUTTONS.CANCEL_BTN;
  TASK_FORM_LABELS = TASK_FORM_LABELS;

  SAVE_NOTIFICATION = NOTIFICATION_MODAL_TYPE.SAVE;
  LABEL_RESPONSIBLE = TASK_CONSTANTS.LABELS.SELECT_RESPONSIBLE;

  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  secondaryButtonClass = STYLE_CLASSES.SECONDARY_BTN;
  roundBtnClassPrimary = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  cardClass = STYLE_CLASSES.CARD;
  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];

  configResponsibles = {
    responsible: VALUES_RESPONSIBLES.PATIENT,
    patient: {
      label: TASK_CONSTANTS.LABELS.RADIO_PATIENT,
      value: VALUES_RESPONSIBLES.PATIENT
    },
    administrator: {
      label: TASK_CONSTANTS.LABELS.RADIO_ADMINISTRATOR,
      value: VALUES_RESPONSIBLES.ADMINISTRATOR
    }
  };
  roleName = "";

  modalConfirmationText = "";
  modalConfirmationTitle = "";
  dialogConfirmation = false;
  addFormTemplateDialog = false;
  notificationDialog = false;
  isEditingNotification = false;
  editingNotification: NotificationConfig = {} as NotificationConfig;
  notificationIndex = -1;
  nameTask = "";

  listResponsibles: DynamicSelectData[] = [];
  responsibleChosen: DynamicSelectData[] = [];
  lastRefResponsible = "";
  selectedResponsible: string[] = [];
  reportValidations: Array<ReportValidationsForm> = [];

  responsibleSelectConfig: DynamicSelectConfig = {
    multiple: true,
    default: [],
    listAll: [],
    chips: true,
    filled: false,
    messageLabel: this.INPUT_RESPONSIBLE,
    notFound: false,
    persistenthint: true,
    loadingData: true
  };

  lastRefDependency = "";
  dependencyChosen: DynamicSelectData[] = [];
  dependencySelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: [],
    chips: true,
    filled: false,
    messageLabel: this.INPUT_DEPENDENCY,
    notFound: false,
    persistenthint: true,
    loadingData: true
  };

  listRelated: DynamicSelectData[] = [];
  relatedChosen: DynamicSelectData[] = [];
  lastRefRelated = "";
  countRelatedChosen = 0;
  countSelectBoard = this.selectCountUsers;
  textAlert = "";
  valueExpansion = 0;

  relatedSelectConfig: DynamicSelectConfig = {
    multiple: true,
    default: [],
    listAll: [],
    chips: true,
    filled: false,
    messageLabel: this.INPUT_RELATED,
    notFound: false,
    persistenthint: true,
    loadingData: true
  };
  word = "";
  daysToApply = 0;
  menu = false;
  date = null;
  time = null;
  minDate = new Date().toISOString().split("T")[0]; // Fecha mínima: hoy
  dateTime = "";
  accentColor = STYLE_CLASSES.CHIP_COLOR.ACCENT;
  clickDateTime = false;
  clickDateToApply = false;

  mounted() {
    this.loadResponsibles();
    this.preloadRelated();
  }

  openDateDialog() {
    this.menu = true;
  }

  @Watch("daysToApply")
  convertDaysToApplyInDateTime() {
    if (this.clickDateTime) {
      this.clickDateTime = false;
      return;
    }
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + Number(this.daysToApply));
    this.date = currentDate.toISOString().split("T")[0] as any;
    this.time = currentDate
      .toISOString()
      .split("T")[1]
      .substring(0, 5) as any;
    this.clickDateToApply = true;
    this.dateTime =
      currentDate.toISOString().split("T")[0] +
      " " +
      currentDate
        .toISOString()
        .split("T")[1]
        .substring(0, 5);
  }

  @Watch("dateTime")
  calcularDiasFaltantes() {
    if (this.clickDateToApply) {
      this.clickDateToApply = false;
      return;
    }
    const fechaActual = new Date(); // Obtiene la fecha y hora actual
    const fechaDestino = new Date(this.dateTime); // Convierte la fecha futura a objeto Date

    const diferenciaMs = Number(fechaDestino) - Number(fechaActual); // Diferencia en milisegundos
    this.clickDateTime = true;
    this.daysToApply = Number(
      (diferenciaMs / (1000 * 60 * 60 * 24)).toFixed(2)
    ); // Convertir a días
  }

  @Watch("task.formTemplates")
  selectTask() {
    if (
      this.nameTask === "" &&
      this.task.formTemplates &&
      this.task.formTemplates.length > 0
    ) {
      this.nameTask = (this.task.formTemplates[0] as SectionGroupDetail).name;
    }
  }

  @Watch("responsibleChosen")
  getSelectedResponsible() {
    this.selectedResponsible = this.responsibleChosen.map(
      responsible => responsible.id
    );
  }

  disableSaveButton() {
    return (
      (!this.task.formTemplates && this.notifications.length == 0) ||
      (this.task.formTemplates?.length == 0 &&
        this.notifications.length == 0) ||
      this.nameTask === "" ||
      (this.selectedResponsible.length == 0 &&
        this.configResponsibles.responsible ===
          this.configResponsibles.administrator.value) ||
      this.relatedChosen.length == 0
    );
  }

  openAddFormTemplates() {
    if (
      (this.selectedResponsible.length > 0 &&
        this.configResponsibles.responsible ===
          this.configResponsibles.administrator.value) ||
      this.configResponsibles.responsible ===
        this.configResponsibles.patient.value
    ) {
      this.addFormTemplateDialog = true;
    } else Snackbar.popWarning(TASK_CONSTANTS.TASK_SNACKBAR.NO_RESPONSIBLE);
  }

  deleteFormTemplate(index: number) {
    this.task.formTemplates?.splice(index, 1);
  }

  closeFormTempDialog() {
    this.addFormTemplateDialog = false;
  }

  save() {
    this.modalConfirmationTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
    this.modalConfirmationText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
    this.dialogConfirmation = true;
  }

  cancel() {
    this.modalConfirmationTitle = FORM_MESSAGES.CANCEL_MODAL.TITLE;
    this.modalConfirmationText = FORM_MESSAGES.CANCEL_MODAL.MESSAGE;
    this.dialogConfirmation = true;
  }

  async handleModalAccept() {
    this.dialogConfirmation = false;
    if (this.modalConfirmationTitle === FORM_MESSAGES.CANCEL_MODAL.TITLE) {
      this.$emit(TASK_CONSTANTS.EVENTS.CANCEL);
    } else if (this.modalConfirmationTitle === FORM_MESSAGES.SAVE_MODAL.TITLE) {
      const newAction = this.fillNewAction();
      this.$emit(ACTION_CARD_EVENT.SEND_DATA_ACTION, newAction);
    }
  }

  handleModalCancel() {
    this.dialogConfirmation = false;
  }

  getTaskData(): Task | void {
    if (this.task.formTemplates && this.task.formTemplates.length > 0) {
      const templates = this.task.formTemplates as SectionGroupDetail[];
      const task: Task = {
        dateAvailable: Date.now(),
        formTemplate: templates[0].id,
        form: "",
        responsible:
          this.configResponsibles.responsible == VALUES_RESPONSIBLES.PATIENT
            ? []
            : this.selectedResponsible,
        related: this.relatedChosen.map(item => item.id),
        required: true,
        state: TASK_CONSTANTS.STATE.PENDING,
        name: this.nameTask,
        affected: this.configResponsibles.responsible
      };

      if (this.dateTime) {
        const dateToExecute = new Date(this.dateTime);
        task.dateToExecute = dateToExecute.getTime();
      }

      return task;
    }
  }

  clearTaskData() {
    this.task = {
      eventDate: "",
      startDate: 0,
      formTemplates: []
    };
    this.notifications = [];
    this.navigateBtnTasks = 0;
    this.modalConfirmationText = "";
    this.modalConfirmationTitle = "";
    this.dialogConfirmation = false;
    this.addFormTemplateDialog = false;
    this.notificationDialog = false;
    this.reportValidations = [];
  }

  fillNewAction(): ActionParameters | void {
    const task = this.getTaskData();
    if (task) {
      const newAction: ActionParameters = {
        ids: this.userIdArray,
        type: ACTION_EVENT.TASK,
        notificationData: this.mainFilter,
        notifications: this.notifications,
        task
      };
      return newAction;
    }
  }

  openAddNotifications() {
    this.notificationDialog = true;
  }

  editNotification(index: number) {
    this.editingNotification = lodash.cloneDeep(this.notifications[index]);
    this.notificationDialog = true;
    this.notificationIndex = index;
    this.isEditingNotification = true;
  }

  acceptNotification(notification: NotificationConfig) {
    this.notificationDialog = false;
    this.isEditingNotification = false;
    this.notifications.push(notification);
  }

  editedNotification(editedNotification: NotificationConfig) {
    this.notifications[this.notificationIndex] = editedNotification;
    this.notificationDialog = false;
    this.isEditingNotification = false;
  }

  cancelNotification() {
    this.notificationDialog = false;
    this.isEditingNotification = false;
    this.notificationIndex = -1;
  }

  deleteNotification(index: number) {
    this.notifications.splice(index, 1);
    this.notificationIndex = -1;
  }

  async preloadRelated() {
    if (this.defaultRelated && this.defaultRelated.length > 0) {
      const users = await this.getUserByIds(this.defaultRelated);
      this.listRelated = [...this.listRelated, ...users];
      this.relatedChosen = users;
      this.relatedSelectConfig.listAll = this.listRelated;
      if (this.fromProfile) {
        this.relatedSelectConfig.disabled = true;
        return;
      }
    }
    this.loadRelated();
  }

  async loadResponsibles(name?: string) {
    this.responsibleSelectConfig.loadingData = true;
    try {
      if (name && name !== "") {
        const users = await this.handleUserByName(name);
        if (Object.keys(users).length === 0) {
          this.responsibleSelectConfig.loadingData = false;
          return;
        }
        const usersList: DynamicSelectData[] = users.userArray.map(item => ({
          id: item.id as string,
          name: item.name as string,
          userAvatar: item.userAvatar,
          userDocument: item.userDocument,
          userPhone: item.userPhone
        }));

        this.listResponsibles = !this.lastRefResponsible
          ? usersList
          : [...this.listResponsibles, ...usersList];

        this.lastRefResponsible = users.lastReference
          ? users.lastReference.toString()
          : "";
        this.responsibleSelectConfig.listAll = this.listResponsibles;
        this.responsibleSelectConfig.loadingData = false;
        return;
      }
      const filterQuery: UserQuery = {
        userState: USER_STATES.ACTIVE,
        idReference: this.lastRefResponsible
      };

      if (this.dependencyChosen.length > 0) {
        filterQuery.dependency = [this.dependencyChosen[0].name];
      }

      const response = await this.userService.getUserByFilters(filterQuery);

      this.responsibleSelectConfig.notFound = response.code === Http.NotFound;
      if (response.code === Http.Found && response.data) {
        const responseData = response.data;
        const responseArray = responseData.userArray as DynamicSelectData[];
        this.listResponsibles = !this.lastRefResponsible
          ? responseArray
          : [...this.listResponsibles, ...responseArray];

        this.lastRefResponsible = responseData.lastReference
          ? responseData.lastReference.toString()
          : "";
      }
    } catch (error) {
      Snackbar.popError(TASK_CONSTANTS.TASK_SNACKBAR.REQUEST_FAILED);
    }
    this.responsibleSelectConfig.loadingData = false;
    this.responsibleSelectConfig.listAll = this.responsibleSelectConfig.listAll.concat(
      this.listResponsibles
    );
  }
  async loadRelated(name?: string) {
    this.relatedSelectConfig.loadingData = true;
    try {
      if (name && name !== "" && name !== this.word) {
        this.word = name;
        this.lastRefResponsible = "";
        const users = await this.handleUserByName(name);
        this.listRelated = [
          ...this.listRelated,
          ...users.userArray.map(item => ({
            id: item.id as string,
            name: item.name as string
          }))
        ];

        this.relatedSelectConfig.listAll = this.listRelated;
        this.relatedSelectConfig.loadingData = false;
        return;
      }
      const filterQuery = {
        userRole: LOGIN_CONSTANTS.ROLE_PATIENT,
        userState: USER_STATES.ACTIVE,
        dependency: [ADMIN_DEPENDENCY],
        lastReference: this.lastRefRelated
      };
      const response = await this.userService.getUserByFilters(filterQuery);
      this.relatedSelectConfig.notFound = response.code === Http.NotFound;
      if (response.code === Http.Found && response.data) {
        const responseData = response.data;
        const responseArray = responseData.userArray as DynamicSelectData[];
        this.listRelated = [...this.listRelated, ...responseArray];

        this.lastRefRelated = responseData.lastReference
          ? responseData.lastReference.toString()
          : "";
        this.relatedSelectConfig.listAll = this.listRelated;
      }
    } catch (error) {
      Snackbar.popError(TASK_CONSTANTS.TASK_SNACKBAR.REQUEST_FAILED);
    }

    this.countRelatedChosen = Object.keys(this.relatedChosen).length;
    this.textAlert =
      TASK_CONSTANTS.MESSAGES_DIFFERENCES.TEXT_1 +
      " " +
      this.countRelatedChosen +
      " " +
      TASK_CONSTANTS.MESSAGES_DIFFERENCES.TEXT_2 +
      " " +
      this.countSelectBoard +
      " " +
      TASK_CONSTANTS.MESSAGES_DIFFERENCES.TEXT_3;

    if (this.countRelatedChosen == this.countSelectBoard) {
      this.valueExpansion = -1;
    }
    this.relatedSelectConfig.loadingData = false;
  }

  async handleUserByName(name: string): Promise<UserPagination> {
    const filterQuery: UserQuery = {
      name: [name],
      state: USER_STATES.ACTIVE,
      notPaginate: true
    };
    delete filterQuery.idReference;
    if (this.dependencyChosen.length > 0) {
      filterQuery.dependency = [this.dependencyChosen[0].name];
    }

    const responseUsers = await this.userService.getUsersByFiltersArrayUsersCrud(
      filterQuery
    );

    if (responseUsers.code == Http.Found && responseUsers.data) {
      const response = responseUsers.data;
      return response;
    } else return {} as UserPagination;
  }

  async getUserByIds(usersId: string[]): Promise<DynamicSelectData[]> {
    const responseUsers = await this.userService.getUsersByIdsArray({
      usersId
    });
    if (responseUsers.code == Http.Found && responseUsers.data) {
      const response = responseUsers.data as DynamicSelectData[];
      return response;
    } else return [];
  }

  async loadDependencies(name?: string) {
    this.dependencySelectConfig.loadingData = true;
    try {
      if (name && name !== "") {
        const dependenciesResponse = await this.dependenciesService.getDependenciesWithFilters(
          {
            state: [DOCUMENT_STATES.ACTIVE],
            name: name
          }
        );
        if (
          dependenciesResponse.code === Http.Found &&
          dependenciesResponse.data
        ) {
          const mooreDependencies = dependenciesResponse.data.data.map(item => {
            return { id: item.id as string, name: item.name as string };
          });
          this.dependencySelectConfig.listAll = mooreDependencies;
          this.dependencySelectConfig.loadingData = false;
          this.lastRefDependency = dependenciesResponse.data.docRef;
          return;
        }
      }
      const filterQuery: QuerySendMultiple = {
        state: [FILTER_QUERY_DEFAULT_DEPENDENCIES.userState],
        docref: this.lastRefDependency,
        name: name
      };
      const dependenciesResponse = await this.dependenciesService.getDependenciesWithFilters(
        filterQuery
      );
      if (
        dependenciesResponse.code === Http.Found &&
        dependenciesResponse.data
      ) {
        const mooreDependencies = dependenciesResponse.data.data.map(item => {
          return { id: item.id as string, name: item.name as string };
        });
        this.dependencySelectConfig.listAll.concat(mooreDependencies);
        this.dependencySelectConfig.loadingData = false;
        this.lastRefDependency = dependenciesResponse.data.docRef;
        return;
      }
    } catch (error) {
      Snackbar.popError(TASK_CONSTANTS.TASK_SNACKBAR.REQUEST_FAILED);
    }
    this.dependencySelectConfig.loadingData = false;
  }

  async setResponsibles(responsable: string) {
    try {
      if (responsable === VALUES_RESPONSIBLES.ADMINISTRATOR) {
        const dependenciesResponse = await this.dependenciesService.getDependenciesWithFilters(
          {
            state: [DOCUMENT_STATES.ACTIVE]
          }
        );
        if (
          dependenciesResponse.code === Http.Found &&
          dependenciesResponse.data
        ) {
          this.dependencySelectConfig.listAll = dependenciesResponse.data.data.map(
            item => {
              return { id: item.id as string, name: item.name as string };
            }
          );
          return;
        }
        Snackbar.popInfo(dependenciesResponse.message);
      }
    } catch (error) {
      Snackbar.popError(TASK_CONSTANTS.TASK_SNACKBAR.REQUEST_FAILED);
    }
  }

  @Watch("dependencyChosen")
  loadUsers() {
    this.lastRefResponsible = "";
    this.responsibleSelectConfig.loadingData = true;
    this.responsibleSelectConfig.listAll = this.responsibleChosen;
    this.loadResponsibles();
  }

  deleteUserChosen(item: DynamicSelectData) {
    this.responsibleChosen = this.responsibleChosen.filter(
      user => user.id !== item.id
    );
  }

  avoidKey(e: KeyboardEvent) {
    const keysToPrevent = ["e", "+", "-", ",", "."];
    if (keysToPrevent.includes(e.key)) e.preventDefault();
  }

  setDateTime() {
    if (this.date && this.time) {
      this.dateTime = `${this.date} ${this.time}`;
      this.menu = false;
    }
  }
}
